module.exports = __webpack_public_path__ + "media/images/flags/64/Sierra-Leone-588aa69b67f9eaf4d74b27cb8071a511.png";